// @file Composable for whiteboard custom event handlers
import { triggerLinking } from '@@/bits/whiteboard_linking'
import { INTERACT_TOOL } from '@@/bits/whiteboard_tools'
import { useWhiteboardLinkingStore } from '@@/pinia/whiteboard_linking'
import { useWhiteboardSpecialEffectsStore } from '@@/pinia/whiteboard_special_effects'
import { useWhiteboardAttachmentInteraction } from '@@/vuecomposables/use_whiteboard_attachment_interaction'
import type { Editor, TLShapeId } from 'tldraw'

export const useWhiteboardCustomEventHandlers = (editor: Editor): void => {
  const whiteboardLinkingStore = useWhiteboardLinkingStore()
  const whiteboardSpecialEffectsStore = useWhiteboardSpecialEffectsStore()
  const { executeShapeInteractions, canInteractWithShape } = useWhiteboardAttachmentInteraction()

  const handleShapeInteraction = (shapeId: TLShapeId): void => {
    const linking = whiteboardLinkingStore.getLinking(shapeId)

    // If a shape already has a linking, we trigger the linking instead of the default interaction of the shape
    if (linking) {
      triggerLinking(editor, linking)
    } else {
      const shape = editor.getShape(shapeId)
      if (canInteractWithShape(shape)) {
        executeShapeInteractions({ shape })
      }
    }

    // We play the special effects regardless of whether the shape has linking or not
    whiteboardSpecialEffectsStore.triggerSpecialEffectForShape(shapeId)
  }

  // `selected-shape` is a custom event that we patched to be emitted when a shape is selected
  // @ts-expect-error Argument of type '"selected-shape"' is not assignable to parameter of type 'keyof TLEventMap'.ts(2345)
  editor.on('selected-shape', ({ shapeId }) => {
    const currentTool = editor.getCurrentToolId()
    if (currentTool === INTERACT_TOOL.tldrawToolId) {
      handleShapeInteraction(shapeId)
    }
  })
}
